export const WHITESPACE_CLASSES = {
    normal: ['whitespace-normal'],
    nowrap: ['whitespace-nowrap'],
    pre: ['whitespace-pre'],
    'pre-line': ['whitespace-pre-line'],
    'pre-wrap': ['whitespace-pre-wrap'],
    'break-spaces': ['whitespace-break-spaces'],
};
